import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { WorklinePrototyp } from '../../assets/shared/workline.object';

declare global {
    interface Date {
        localISOString():any;
    }
}

@Component({
  selector: 'rcs-modal-workline',
  templateUrl: 'rcs-modal-workline.html'
})
export class RcsModalWorkline implements OnInit{

  private workline_form:FormGroup
  private workline_element: any
  private dates = {};
  public error_msg: string
  private autofocus: Boolean = false;
  @ViewChild('nameInput') nameInput;

  constructor(
    private view_controller: ViewController,
    private params: NavParams,
    private formBuilder: FormBuilder){
      this.workline_form = this.formBuilder.group({
        name: ['', Validators.required],
        start: ['', Validators.required],
        end: ['', Validators.required],
      });
    }

  ngOnInit(){
    if (this.params.get('workline')){
      this.workline_element = this.params.get('workline');
    }else{
      this.workline_element = new WorklinePrototyp();
      this.autofocus = true;
    }
    this.create_ISO_Date();
  }

  ngAfterViewChecked() {
    if (this.autofocus) {
      this.nameInput.setFocus();
    }
  }

  private create_ISO_Date(){
      Date.prototype.localISOString = function() {
          var tzo = -this.getTimezoneOffset(),
          dif = tzo >= 0 ? '+' : '-',
          pad = function(num) {
          var norm = Math.floor(Math.abs(num));
          return (norm < 10 ? '0' : '') + norm;
      };
      return this.getFullYear() +
          '-' + pad(this.getMonth() + 1) +
          '-' + pad(this.getDate()) +
          'T' + pad(this.getHours()) +
          ':' + pad(this.getMinutes()) +
          ':' + pad(this.getSeconds()) +
          dif + pad(tzo / 60) +
          ':' + pad(tzo % 60);
      }
      let von = new Date();
      let bis = new Date();
      if (this.workline_element.von && this.workline_element.bis){
          von = new Date(this.workline_element.von + ' UTC');
          bis = new Date(this.workline_element.bis + ' UTC');
          if (isNaN(von.getTime())){
              von = new Date(this.workline_element.von);
              bis = new Date(this.workline_element.bis);
          }
      }
      this.dates['von'] = von.localISOString();
      this.dates['bis'] = bis.localISOString();
    }

    public submit(prototyp:any){
        let result = this.workline_form.value;
        prototyp.name = result.name;
        prototyp.von = new Date(new Date(result.start).setSeconds(0)).toISOString();
        prototyp.bis = new Date(new Date(result.end).setSeconds(0)).toISOString();
        prototyp.dauer = this.get_duration();
        let workline_work_element = this.validate_prototyp(prototyp);
        console.log(workline_work_element.dauer);
        if (workline_work_element.dauer > 0 && workline_work_element.dauer < 24){
          this.copy_values(workline_work_element);
          this.view_controller.dismiss({'workline': this.workline_element});
        }else{
          this.error_msg = 'Die Arbeitszeit darf nicht 0 und nicht mehr als 24 Stunden betragen!';
        }
    }

    public abort(prototyp:any){
      this.view_controller.dismiss();
    }

    private copy_values(prototyp:any){
      this.workline_element.name = prototyp.name;
      this.workline_element.von = prototyp.von;
      this.workline_element.bis = prototyp.bis;
      this.workline_element.dazer = prototyp.dauer;
    }

    private get_duration(): number{
        let start = new Date(this.workline_element.von);
        let end = new Date(this.workline_element.bis);
        return (end.getTime() - start.getTime()) / 36e5;
    }

    private validate_prototyp(workline:any){
        workline.dauer = parseFloat(workline.dauer);
        return workline;
    }
}



// WEBPACK FOOTER //
// ./src/components/rcs-modal-workline/rcs-modal-workline.ts